<script lang="ts">
  import {preview, step, thumbDraft, thumbnail, menu} from '../../store';
  import {onDestroy} from 'svelte';
  import {STEP, MENU} from '@/types/common';
  import {draftName} from '@/store/drafts';
  let currentAnalysis: NodeJS.Timeout | null = null;

  let previousThumbnailState: string | null = null;
  let previousPreviewState: string | null = null;

  function analyzeThumbDraftChanges() {
    console.log('Analyzing Thumbnail Draft Changes');
    if (currentAnalysis) clearTimeout(currentAnalysis);
    if ($menu !== MENU.THUMBNAILS) return;
    currentAnalysis = setTimeout(() => {
      if ($step === STEP.CHOOSE_VIDEO || !$thumbnail.video) return;
      console.log('Saving Thumbnail Draft');
      let _thumbnail = JSON.parse(JSON.stringify($thumbnail));
      let _preview = JSON.parse(JSON.stringify($preview));
      if (!_thumbnail.video) return;
      try {
        delete _thumbnail.video?.transcription;
      } catch (err) {
        console.warn('Could not delete transcriptions from index');
      }

      // Check if there are actual changes before updating
      const currentThumbnailState = JSON.stringify(_thumbnail);
      const currentPreviewState = JSON.stringify(_preview);

      if (currentThumbnailState !== previousThumbnailState || currentPreviewState !== previousPreviewState) {
        console.log('Changes detected, updating thumbnail draft');
        thumbDraft.updateDraft(_thumbnail, $draftName, _preview);
        previousThumbnailState = currentThumbnailState;
        previousPreviewState = currentPreviewState;
      } else {
        console.log('No changes detected, skipping thumbnail draft update');
      }

      currentAnalysis = null;
    }, 10000); // Debounce
  }

  const unsubscribeSteps = step.subscribe(step => {
    analyzeThumbDraftChanges();
  });

  const unsubscribeThumbProject = thumbnail.subscribe(t => {
    analyzeThumbDraftChanges();
  });

  const unsubscribePreview = preview.subscribe(() => {
    analyzeThumbDraftChanges();
  });

  const unsubscribeDraftName = draftName.subscribe(name => {
    analyzeThumbDraftChanges();
  });

  onDestroy(() => {
    unsubscribeThumbProject();
    unsubscribeSteps();
    unsubscribePreview();
    unsubscribeDraftName();
    if (currentAnalysis) clearTimeout(currentAnalysis);
  });
</script>
